import { createSelector } from 'reselect';
import ItemsHandoverDataAirDetailsColumns
  from '../../containers/ItemsHandoverDataAirDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ItemsHandoverDataAirDetailsColumns);
